<template>
  <div class="renwu">
    <!-- 结账单生成 -->
    <div class="top">
      <Select v-model="model1" class="select" @on-change="getSelect">
        <Option
          v-for="(item, index) in typeList"
          :value="item.name"
          :key="index"
          >{{ item.name }}</Option
        >
      </Select>
      <Select
        v-if="
          this.model1 == '已完成检查订单' || this.model1 == '已到检检查订单'
        "
        v-model="model2"
        class="select"
        @on-change="getSelect2"
      >
        <Option
          v-for="(item, index) in sucessList"
          :value="item.name"
          :key="index"
          >{{ item.name }}</Option
        >
      </Select>
      <Button
        :disabled="disabled"
        @click="generateStatement"
        class="btn fiveSize"
        type="success"
        ghost
        >生成结账单</Button
      >
    </div>
    <div class="table-cont">
      <Table
        @on-selection-change="selectChange"
        @on-sort-change="changesort"
        stripe
        :columns="columns"
        :data="data"
      ></Table>
    </div>
    <div class="page-div">
      <div class="page-div-left">
        已选 <span>{{ selectNum }}</span> 条
      </div>
      <Page
        :total="obj.total"
        @on-page-size-change="changepeoplepage"
        @on-change="changePeoplecurrent"
        show-elevator
        show-total
        :current="current"
        :page-size="pageSize"
        show-sizer
        class="page-div-page"
      />
    </div>

    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success"
      >操作成功</Alert
    >
    <Alert
      class="alertTitle"
      v-show="alertTitleIshow2"
      type="error"
      show-icon
      >{{ alertTitle }}</Alert
    >

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->

    <!--  -->

    <Modal
      class="ivumodal"
      width="500"
      v-model="errors"
      title="提示"
      footer-hide
    >
      <div class="ivumodal-cont">
        请选择订单
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="ok(2)">取消</Button>
        <Button class="btn sure" type="success" ghost @click="ok(2)"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
    import {
        formatMoney,
        selectOrderList2,
        generateStatement
    } from "../servers/api";
    export default {
        name: "renwu",
        data() {
            return {
                isiconfontshow: false,
                alertTitleIshow: false,
                alertTitleIshow2: false,
                alertTitle: "",
                typeList: [{
                    name: "已完成检查订单"
                }, {
                    name: "未完成检查订单"
                }, {
                    name: "已到检检查订单"
                }], //select选择筛选
                model1: "已完成检查订单",
                model2: "未生成结账单",
                sucessList: [{
                    name: "已生成结账单"
                }, {
                    name: "未生成结账单"
                }],
                data: [],
                background: "#fff",
                columns: [{
                    type: "selection",
                    width: 50,
                    align: "center",
                    fixed: "left"
                }, {
                    title: "姓名",
                    width: 150,
                    align: "center",
                    key: "patientName",
                    ellipsis: true,
                    sortable: true
                }, {
                    title: "性别",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "sex",
                    width: 150
                }, {
                    title: "年龄",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "age",
                    width: 150
                }, {
                    title: "手机号",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "phone",
                    width: 180
                }, {
                    title: "是否到检",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "examFlag",
                    width: 170,
                    render: (h, params) => {
                        let a = "";
                        if (params.row.examFlag == 2) {
                            a = "是";
                        } else {
                            a = "否";
                        }
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        height: "30px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        "line-height": "37px",
                                        color: "#7F7F7F"
                                    }
                                },
                                a
                            )
                        ]);
                    }
                }, {
                    title: "支付时间",
                    align: "center",
                    ellipsis: true,
                    width: 190,
                    sortable: true,
                    key: "payTime"
                }, {
                    title: "项目金额",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "unitPrice",
                    width: 170,
                    render: (h, params) => {
                        let a = "￥" + formatMoney(params.row.unitPrice);
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        height: "30px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        "line-height": "37px",
                                        color: "#7F7F7F"
                                    }
                                },
                                a
                            )
                        ]);
                    }
                }, {
                    title: "检查状态",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "medicalStatus ",
                    width: 170,
                    render: (h, params) => {
                        let a = "";
                        if (params.row.medicalStatus == 0) {
                            a = "未完成";
                        } else {
                            a = "已完成";
                        }
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        height: "30px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        "line-height": "37px",
                                        color: "#7F7F7F"
                                    }
                                },
                                a
                            )
                        ]);
                    }
                }, {
                    title: "结账单状态",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "statementStatus",
                    width: 170,
                    render: (h, params) => {
                        let a = "";
                        if (params.row.statementStatus == 0) {
                            a = "未生成";
                        } else {
                            a = "已生成";
                        }
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        height: "30px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        "line-height": "37px",
                                        color: "#7F7F7F"
                                    }
                                },
                                a
                            )
                        ]);
                    }
                }, {
                    title: "生成人",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "unitPrice",
                    width: 170
                }],
                current: 1,
                disabled: false,
                orderField: "",
                isAsc: "",
                obj: {},
                pageSize: 20,
                medicalStatus: "1",
                statementStatus: "0",
                selectNum: 0, //已选数量
                selectList: [],
                errors: false
            };
        },
        created() {
            this.selectOrderList();
        },
        methods: {
            ok() {
                this.errors = false;
            },
            generateStatement() {
                //生成结账单
                if (this.selectNum == 0) {
                    this.errors = true;
                    return;
                }
                this.isiconfontshow = true;
                let list = [];
                for (let i = 0; i < this.selectList.length; i++) {
                    if (this.selectList[i].id) {
                        list.push(this.selectList[i].id);
                    }
                }
                let params = {
                    orderIdList: list.join(",")
                };
                generateStatement(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);

                        this.selectOrderList(1);
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            selectChange(item) {
                //表格select选中
                this.selectList = item;
                this.selectNum = this.selectList.length;
            },
            changepeoplepage(num) {
                //换每页请求多少条
                this.pageSize = num;
                this.selectOrderList(1);
            },
            changePeoplecurrent(num) {
                //换页
                this.current = num;
                this.selectOrderList();
            },
            selectOrderList(index) {
                this.isiconfontshow = true;
                if (index) {
                    this.current = 1;
                }
                let params = {
                    pageNum: this.current,
                    pageSize: this.pageSize,
                    medicalStatus: this.medicalStatus, //结账单状态(0-未提交 1-已提交 2-已结算)
                    orderField: this.orderField,
                    isAsc: this.isAsc,
                    statementStatus: this.statementStatus
                };
                this.selectChange([]);
                selectOrderList2(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.obj = res.data.data || {};
                        this.data = res.data.data.list || [];
                    }
                });
            },
            changesort(item) {
                //排序
                this.orderField = item.key;
                this.isAsc = item.order;
                this.current = 1;
                if (item.order == "normal") {
                    this.isAsc = "";
                    this.orderField = "";
                }
                this.selectOrderList(1);
            },
            getSelect(name) {
                //任务创建时间select
                if (this.model1 == "未完成检查订单") {
                    this.medicalStatus = "0";
                    this.statementStatus = "";
                    this.disabled = true;
                    this.selectOrderList(1);
                } else if (this.model1 == "已完成检查订单") {
                    this.medicalStatus = "1";
                    // this.model2 == "未生成结账单";
                    this.getSelect2(this.model2);
                } else {
                    //已到检检查订单
                    this.medicalStatus = "2";
                    this.getSelect2(this.model2);
                }
            },
            getSelect2(name) {
                //任务创建时间select
                if (this.model2 == "已生成结账单") {
                    this.disabled = true;
                    this.statementStatus = "1";
                } else {
                    this.disabled = false;
                    this.statementStatus = "0";
                }
                this.selectOrderList(1);
            }
        }
    };
</script>
<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .renwu {
        font-size: 13px;
        padding: 15px;
        width: 100%;
        height: 100%;
        overflow: hidden;
        overflow-y: scroll;
        overflow-y: visible;
        .btn {
            float: right;
        }
        .top {
            width: calc(100% - 250px);
            height: 60px;
            line-height: 35px;
            position: fixed;
            top: 111px;
            z-index: 99;
            background: #fff;
            padding-top: 17px;
            left: 220px;
            padding-left: 15px;
            padding-bottom: 15px;
        }
        .select {
            width: 130px;
            margin-right: 10px;
        }
        .journal-input {
            width: 250px;
            vertical-align: top;
        }
        .data {
            width: 250px;
            vertical-align: top;
        }
        .table-cont {
            padding-top: 15px;
            margin: 40px 0 60px;
        }
        .page-div {
            width: 100%;
            margin-top: 15px;
            position: fixed;
            background: #fff;
            width: calc(100% - 270px);
            height: 60px;
            z-index: 99;
            bottom: 0;
            padding-top: 15px;
            .page-div-left {
                float: left;
            }
            .page-div-page {
                float: right;
                margin-right: 15px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/caiwu/jiezhang.vue